<template>
  <div class="container">
    <Breadcrumb class="breadcrumb">
      <BreadcrumbItem to="/">
        <Icon type="ios-home" class="home" />首页
      </BreadcrumbItem>
      <BreadcrumbItem>学习中心</BreadcrumbItem>
      <BreadcrumbItem>{{ courseName }}</BreadcrumbItem>
      <BreadcrumbItem>错题本</BreadcrumbItem>
    </Breadcrumb>

    <div class="practice-header">
      <div class="practice-title">
        <h1>{{ courseName }}</h1>
      </div>
      <div class="practice-progress">
        <span class="practice-progress-text">共 {{ allListTotal }} 道题</span>
        <div class="practice-progress-bar">
          <Progress :percent="progressPercent" />
        </div>
      </div>
    </div>

    <div class="practice-container clearfix">
      <div class="fl practice-main">
        <div
          class="practice-nodata"
          v-if="
            !singleList.length && !multipleList.length && !subjectiveList.length
          ">
          <img
            src="../../assets/images/nodata-03.png"
            alt="错题本内还没有错题" />
          <p class="am-margin-top">错题本内还没有错题</p>
        </div>
        <!-- v-for="(item, index) in exerciseList" -->
        <template v-else>
          <practice-item
            ref="practiceItem"
            :key="exerciseInfo.exerId"
            :data="exerciseInfo"
            :index="exerciseInfo.headIndex"
            practiceType="wrong"
            v-model="exerciseInfo.userKey"
            @on-check="changeProgress"
            @on-delete="deleteWrong"
            @on-select="getCurrentDate"></practice-item>
          <!-- @on-last="lastPractice"
          @on-next="nextPractice" -->
          <div class="change-next-btn">
            <Button :disabled="showLastBtn" type="primary" @click="lastPractice"
              >上一题</Button
            >
            <Button :disabled="showNextBtn" type="primary" @click="nextPractice"
              >下一题</Button
            >
          </div>
        </template>
      </div>
      <div class="fr practice-bar">
        <Affix :offset-top="160">
          <div class="practice-sheet">
            <h3 class="practice-sheet-header">答题卡</h3>
            <p class="practice-sheet-note">点击图标跳转到对应的题目</p>
            <div class="practice-sheet-score" v-show="doResultVisible">
              <p>
                正确率
                <span class="right-rate">{{ rightPercent }}%</span>
              </p>
              <p>
                <span class="wrong-num">{{ rightExerciseNum }}</span>
                道题已从错题本删除
              </p>
            </div>
            <div class="practice-sheet-list">
              <happy-scroll
                color="rgba(12, 154, 213 , 1)"
                size="5"
                resize
                hide-horizontal>
                <ul class="practice-sheet-serial clearfix">
                  <div v-if="singleList.length">单选题</div>
                  <li
                    v-for="(item, currIndex) in singleList"
                    :key="item.index"
                    :class="{
                      right: item.doResult == 1,
                      wrong: item.doResult == -1,
                    }">
                    <a
                      v-text="item.index"
                      @click="clickPractice(item, currIndex, 1)"></a>
                  </li>

                  <div v-if="multipleList.length">多选题</div>
                  <li
                    v-for="(item, currIndex) in multipleList"
                    :key="item.index"
                    :class="{
                      right: item.doResult == 1,
                      wrong: item.doResult == -1,
                    }">
                    <a
                      v-text="item.index"
                      @click="clickPractice(item, currIndex, 2)"></a>
                  </li>

                  <div v-if="subjectiveList.length">主观题</div>
                  <li
                    v-for="(item, currIndex) in subjectiveList"
                    :key="item.index"
                    :class="{
                      right: item.doResult == 1,
                      wrong: item.doResult == -1,
                    }">
                    <a
                      v-text="item.index"
                      @click="clickPractice(item, currIndex, 3)"></a>
                  </li>
                </ul>
              </happy-scroll>
            </div>

            <div class="practice-sheet-button" v-show="allListTotal > 0">
              <Button
                v-if="!doResultVisible"
                type="warning"
                long
                @click="submitExercise"
                >提交练习</Button
              >
              <Button v-else type="warning" long @click="reloadPage"
                >重做一遍</Button
              >
            </div>
            <div class="practice-sheet-footer">
              <span>
                <i class="ivu-icon ivu-icon-md-square right"></i> 正确
              </span>
              <span>
                <i class="ivu-icon ivu-icon-md-square wrong"></i> 错误
              </span>
              <span>
                <i class="ivu-icon ivu-icon-md-square empty"></i> 未做
              </span>
            </div>
          </div>
        </Affix>
      </div>
    </div>
  </div>
</template>

<script>
import { siteMixin } from '../../utils/mixin';
import { mall, study } from '../../request';

import PracticeItem from '../../components/exercise/PracticeItem';
import { HappyScroll } from 'vue-happy-scroll';
import 'vue-happy-scroll/docs/happy-scroll.css';
export default {
  mixins: [siteMixin],
  data() {
    return {
      exerciseList: [],
      exerciseInfo: {},
      finishExerciseNum: 0,
      courseName: '',
      catalogInfo: {},
      rightExerciseNum: 0,
      doResultVisible: false,
      singleTotal: 0,
      multipleTotal: 0,
      subjectiveTotal: 0,
      allListTotal: 0,
      requestIndex: 0,

      singleList: [],
      multipleList: [],
      subjectiveList: [],
      // exerciseNum
      allExerciseList: [],
      exerSortTypeNameObj: {
        1: '单选题',
        2: '多选题',
        3: '主观题',
      },
      exerciseMap: {
        1: 'singleList',
        2: 'multipleList',
        3: 'subjectiveList',
      },
      isRequestIndexList: [],

      exerSortType: 1, //答题排序
      singleFlag: false, //答题卡单选
      multipleFlag: false, //答题卡多选
      subjectiveFlag: false, //答题卡主观
      showLastBtn: true,
      showNextBtn: false,
    };
  },
  computed: {
    progressPercent() {
      const totalNum = this.allListTotal;
      if (totalNum <= 0) return 0;
      let percent = (this.finishExerciseNum / totalNum) * 100;
      console.log(this.finishExerciseNum, totalNum, '进度');
      return Number(percent.toFixed(0));
    },
    rightPercent() {
      const totalNum = this.allListTotal;
      if (totalNum <= 0) return 0;
      let rightNum = this.rightExerciseNum;
      let percent = (rightNum / totalNum) * 100;
      return Number(percent.toFixed(0));
    },
  },
  mounted() {
    this.setMetaData('错题本');
    //获取参数
    if (!this.initParams()) return;
    this.getCourseName();
    //this.getExerciseList();
  },
  methods: {
    initParams() {
      let umcId = this.$route.params.id;
      if (umcId) {
        this.setUmcId(umcId);
        return true;
      } else {
        this.$Message.error('参数错误');
        return false;
      }
    },
    // 组装各类型的题目List
    changeList(forEachNum, indexFirst) {
      let tempList = [];
      for (var i = 0; i < forEachNum; i++) {
        let exerciseObj = {
          index: i + 1 + indexFirst,
        };
        tempList.push(exerciseObj);
      }
      return tempList;
    },
    async getExerciseList() {
      this.allExerciseList = [];

      this.singleTotal = await this.getTyleTotal(1);
      this.multipleTotal = await this.getTyleTotal(2);
      this.subjectiveTotal = await this.getTyleTotal(3);
      this.allListTotal =
        this.singleTotal + this.multipleTotal + this.subjectiveTotal;

      this.singleList = this.changeList(this.singleTotal, 0);
      this.multipleList = this.changeList(this.multipleTotal, this.singleTotal);
      this.subjectiveList = this.changeList(
        this.subjectiveTotal,
        this.singleTotal + this.multipleTotal,
      );

      console.log(this.singleTotal, this.multipleTotal, this.subjectiveTotal);
      console.log(this.singleList, this.multipleList, this.subjectiveList);
      this.clickPractice({ index: 1 }, 0, 1);

      // study
      //   .getWrongList(this.umcId,params)
      //   .then((res) => {
      //     console.log("wrongExerList", res);
      //     if (res.status === 1) {
      //       this.exerciseList = res.data;
      //       this.exerciseList.forEach((item) => {
      //         if(item.newKeyType == 1 && !this.singleFlag ){
      //           this.singleFlag = true;
      //         }
      //         if(item.newKeyType == 2 && !this.multipleFlag ){
      //           this.multipleFlag = true;
      //         }
      //         if(item.newKeyType == 3 && !this.subjectiveFlag ){
      //           this.subjectiveFlag = true;
      //         }
      //               this.$set(item, "userKey", "");
      //               this.$set(item, "doResult", 0);
      //       });
      //     }
      //   });
    },
    // 获取各题型总数
    getTyleTotal(newKeyType) {
      let params = {
        courseId: this.courseId,
        userId: this.loginUser.userId,
        pageSize: 1,
        page: 1,
        newKeyType,
      };
      return study.getWrongList(this.umcId, params).then(res => {
        if (res.status === 1) {
          return res.data.total;
        }
      });
    },
    getCourseName() {
      study.getUmcInfo(this.umcId).then(res => {
        if (res.status === 1) {
          console.log(res.data);
          this.courseName = res.data.courseName;
          this.setCourseId(res.data.courseId);
          this.getExerciseList();
        }
      });
    },
    deleteWrong(data) {
      // console.log("delete", data);
      if (data.doResult != 0) {
        this.finishExerciseNum--;
      }
      this.exerciseInfo = {};
      this.exerciseInfo.newKeyType = -1;
      study
        .deleteWrongExercise({
          umcId: this.umcId,
          exerIds: data.exerId,
        })
        .then(res => {
          console.log(res);
          if (res.status === 1) {
            const index = this[this.exerciseMap[data.newKeyType]].indexOf(data);
            this[this.exerciseMap[data.newKeyType]].splice(index, 1);

            data.index = data.headIndex + 2;
            this.allListTotal--;
            this.clickPractice(data, index, data.newKeyType);
          }
        });
    },
    submitExercise() {
      this.doResultVisible = true;
      this.finishExerciseNum = this.allListTotal;
      //检查答案
      this.$refs.practiceItem.checkAnswer();
      // this.$refs.practiceItem.forEach((item) => {
      //   item.checkAnswer();
      // });
      let exerIdSet = '';
      const allList = [
        ...this.singleList,
        ...this.multipleList,
        ...this.subjectiveList,
      ];
      console.log(allList, 'allList11111', this.allListTotal);
      allList.forEach(item => {
        if (
          item.doResult == 1 ||
          (item.userKey && item.userKey == item.rightKey)
        ) {
          console.log(item.userKey, item.rightKey);
          this.rightExerciseNum++;
          if (exerIdSet != '') exerIdSet += '|';
          exerIdSet += item.exerId;
        }
      });
      this.changeDoResult(this.singleList);
      this.changeDoResult(this.multipleList);
      this.changeDoResult(this.subjectiveList);

      console.log(exerIdSet, 'exerIdSet');
      if (!exerIdSet) return;
      study
        .deleteWrongExercise({
          umcId: this.umcId,
          exerIds: exerIdSet,
        })
        .then(res => {
          //console.log(res);
          if (res.status === 1) {
          }
        });
    },
    changeDoResult(singleList) {
      singleList.map(item => {
        if (item.userKey && item.userKey == item.rightKey) {
          item.doResult = 1;
        } else {
          item.doResult = -1;
        }
      });
    },
    // 查看答案
    changeProgress(item) {
      // console.log('查看答案');
      if (this.finishExerciseNum < this.allListTotal) {
        this.finishExerciseNum++;
      }
      this[this.exerciseMap[item.newKeyType]].map(cItem => {
        if (cItem.exerId === item.exerId) {
          cItem.doResult = cItem.userKey === cItem.rightKey ? 1 : -1;
        }
      });

      // if(item.newKeyType == 1){
      //   this.changeExerState(this.singleList,item);
      // }
      // if(item.newKeyType == 2){
      //   this.changeExerState(this.multipleList,item);
      // }
      // if(item.newKeyType == 3){
      //   this.changeExerState(this.subjectiveList,item);
      // }
    },
    // changeExerState(tempList,pItem){
    //   tempList.map(item=>{
    //     if(item.exerId === pItem.exerId){
    //       item.doResult = pItem.userKey === pItem.rightKey ? 1 : -1;
    //     }
    //   })
    // },
    // 选择错题选项回调
    getCurrentDate(data) {
      this[this.exerciseMap[data.newKeyType]].map(item => {
        if (item.exerId === data.exerId) {
          item.userKey = data.userKey;
          // item.doResult = data.userKey === data.rightKey ? 1 : -1;
        }
      });
      console.log(this.singleList, 'this.singleList');
    },
    lastPractice(data) {
      this.requestIndex--;
      this.requestPractice(this.exerciseInfo, this.exerciseInfo.newKeyType);
    },
    nextPractice(data) {
      // console.log('下一题');
      this.requestIndex++;
      this.requestPractice(this.exerciseInfo, this.exerciseInfo.newKeyType);
    },
    requestPractice(item, newKeyType) {
      console.log(this.singleList, 'singleList000');

      // currIndex 当前题型数组index
      let currIndex = 0;
      const clickIndex = this.requestIndex;
      console.log('第' + this.requestIndex + '题');

      if (clickIndex <= this.singleTotal) {
        currIndex = clickIndex;
      } else if (
        clickIndex > this.singleTotal &&
        clickIndex <= this.multipleTotal + this.singleTotal
      ) {
        currIndex = clickIndex - this.singleTotal;
        // console.log(currIndex,'currIndex2222');
      } else if (
        clickIndex > this.singleTotal + this.multipleTotal &&
        clickIndex <= this.allListTotal
      ) {
        currIndex = clickIndex - (this.singleTotal + this.multipleTotal);
        // console.log(currIndex,'currIndex3333333');
      }

      let that = this;
      console.log(this.isRequestIndexList, 'this.isRequestIndexList');

      if (this.isRequestIndexList.includes(this.requestIndex)) {
        this.showLastBtn = this.requestIndex == 1;
        this.showNextBtn = this.requestIndex == this.allListTotal;
        // console.log(currIndex - 1);
        // console.log(this[this.exerciseMap[item.newKeyType]]);
        // console.log(this[this.exerciseMap[item.newKeyType]][currIndex - 1],'this[this.exerciseMap[item.newKeyType]][currIndex-1]');
        if (clickIndex == this.singleTotal) {
          that.exerciseInfo = this.singleList[currIndex - 1];
        } else if (clickIndex == this.multipleTotal + this.singleTotal) {
          that.exerciseInfo = this.multipleList[currIndex - 1];
        } else if (clickIndex == this.allListTotal) {
          that.exerciseInfo = this.subjectiveList[currIndex - 1];
        } else {
          if (
            clickIndex > this.singleTotal &&
            clickIndex <= this.multipleTotal + this.singleTotal
          ) {
            that.exerciseInfo = this.multipleList[currIndex - 1];
          } else if (
            clickIndex > this.singleTotal + this.multipleTotal &&
            clickIndex <= this.allListTotal
          ) {
            that.exerciseInfo = this.subjectiveList[currIndex - 1];
          } else {
            that.exerciseInfo =
              this[this.exerciseMap[item.newKeyType]][currIndex - 1];
          }
        }
        return;
      } else {
        this.isRequestIndexList.push(this.requestIndex);
      }
      // if(item.index){
      //   this.requestIndex = item.index;
      // }

      this.showLastBtn = this.requestIndex == 1;
      this.showNextBtn = this.requestIndex == this.allListTotal;

      let params = {
        courseId: this.courseId,
        userId: this.loginUser.userId,
        pageSize: 1,
        page: this.requestIndex,
      };
      study.getWrongList(this.umcId, params).then(res => {
        if (res.status === 1) {
          this.exerciseInfo = res.data.list[0];
          this.exerciseInfo.userKey = '';
          if (!this.doResultVisible) {
            this.exerciseInfo.doResult = 0;
          }
          this.exerciseInfo.headIndex = this.requestIndex - 1;
          // this.exerciseInfo.headIndex = item.index - 1;
          // this.requestIndex = item.index;
          switch (this.exerciseInfo.newKeyType) {
            case 1:
              this.singleList[currIndex - 1] = {
                ...this.singleList[currIndex - 1],
                ...res.data.list[0],
              };
              break;
            case 2:
              this.multipleList[currIndex - 1] = {
                ...this.multipleList[currIndex - 1],
                ...res.data.list[0],
              };
              break;
            case 3:
              this.subjectiveList[currIndex - 1] = {
                ...this.subjectiveList[currIndex - 1],
                ...res.data.list[0],
              };
              break;
          }
          // console.log(this.singleList,'this.singleList222');
        }
      });
    },
    // 点击右侧答题卡
    clickPractice: function (item, currIndex, newKeyType) {
      // item.index 总数组index
      // currIndex 当前题型数组index
      console.log(this.doResultVisible, 'this.doResultVisible');
      // if(this.doResultVisible) return;
      if (this.isRequestIndexList.includes(item.index)) {
        this.exerciseInfo = item;
        this.showLastBtn = item.index == 1;
        this.showNextBtn = item.index == this.allListTotal;
        return;
      } else {
        this.isRequestIndexList.push(item.index);
      }

      if (item.index) {
        this.requestIndex = item.index;
      }
      console.log(this.requestIndex, 'this.requestIndex ');
      this.showLastBtn = this.requestIndex == 1;
      this.showNextBtn = this.requestIndex == this.allListTotal;

      let params = {
        courseId: this.courseId,
        userId: this.loginUser.userId,
        pageSize: 1,
        page: this.requestIndex,
      };
      study.getWrongList(this.umcId, params).then(res => {
        if (res.status === 1) {
          this.exerciseInfo = res.data.list[0];
          console.log(this.exerciseInfo.userKey, 'this.exerciseInfo.userKey ');
          this.exerciseInfo.userKey = '';
          if (!this.doResultVisible) {
            this.exerciseInfo.doResult = 0;
          }

          this.exerciseInfo.headIndex = item.index - 1;
          // this.requestIndex = item.index;
          switch (newKeyType) {
            case 1:
              this.singleList[currIndex] = {
                ...this.singleList[currIndex],
                ...res.data.list[0],
              };
              break;
            case 2:
              this.multipleList[currIndex] = {
                ...this.multipleList[currIndex],
                ...res.data.list[0],
              };
              break;
            case 3:
              this.subjectiveList[currIndex] = {
                ...this.subjectiveList[currIndex],
                ...res.data.list[0],
              };
              break;
          }
          // console.log(this.singleList,'this.singleList点击右侧答题卡');
          // console.log(this.exerciseInfo);
        }
      });
      // var top = document.querySelectorAll(".practice-item")[i].offsetTop - 162;
      // window.scroll({ top: top, left: 0, behavior: "smooth" });
    },
  },
  components: {
    PracticeItem,
    HappyScroll,
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/var';
@import '../../assets/css/exercise';
.breadcrumb {
  padding: 1rem 0;
  .home {
    vertical-align: -0.05em;
    margin-right: 0.2rem;
  }
}
.practice-nodata {
  padding: 35px;
  img {
    margin: 0 auto;
  }
  p {
    margin-top: 16px;
    text-align: center;
    font-size: 1.8rem;
  }
}
.change-next-btn {
  padding-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  .ivu-btn-primary {
    margin-right: 10px;
  }
}
</style>
